import { format as dateFormat, formatWithOptions, parseISO } from 'date-fns/fp';
import de from 'date-fns/locale/de';
import enGB from 'date-fns/locale/en-GB';
import fr from 'date-fns/locale/fr';
import it from 'date-fns/locale/it';
import nl from 'date-fns/locale/nl';
import sv from 'date-fns/locale/sv';
import { compose } from 'ramda';

import { i18n } from '@i18n';

export const locales = {
    itIT: it,
    frFR: fr,
    deCH: de,
    nlNL: nl,
    svSE: sv,
    enGB
};

export const partitionArr = (array, isValid) => {
    return array.reduce(
        ([pass, fail], elem) => {
            return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
        },
        [[], []]
    );
};

export const propsChanged =
    (props, prevProps) =>
    (...keys) =>
        keys.some((k) => props[k] !== prevProps[k]);

export const transformLanguageCode = (lang = 'en-gb') => {
    const [languageCode, countryCode] = lang.split('-');
    return `${languageCode}${countryCode.toUpperCase()}`;
};

export const parseMinutes = (time) => {
    const [hour, minute] = time.split(':');
    return parseInt(hour, 10) * 60 + parseInt(minute, 10);
};

// Formats time from minutes into 'HH:mm'
export const formatTime = (minutes) =>
    `${String(Math.floor(minutes / 60) % 24).padStart(2, '0')}:${String(minutes % 60).padStart(
        2,
        '0'
    )}`;

// eslint-disable-next-line consistent-return
export const validateProp = (fn) => (props, propName, componentName) => {
    const validProp = fn({ props, propName, componentName });
    if (!validProp) {
        return new Error(
            `Invalid prop \`${propName}\` supplied to \`${componentName}\`. Validation failed.`
        );
    }
};

export const defaultFormat = 'dd MMM yyyy';
export const defaultDateFormatWithFullMonth = 'dd MMMM yyyy';
export const defaultDateTimeFormat = 'dd MMM yyyy, HH:mm';
export const defaultDateTimeFormatWithFullMonth = 'dd MMMM yyyy, HH:mm';
export const defaultTimeFormat = 'HH:mm';
const defaultLocale = 'en-GB';

export const formatDate = (date, format, locale) => {
    if (!date) return '';
    const userLocale = locales[transformLanguageCode(locale || i18n?.language || defaultLocale)];
    return formatWithOptions(
        { locale: userLocale },
        format || defaultFormat,
        date instanceof Date ? date : parseISO(date)
    );
};

export const parseTime = (formatString) => compose(dateFormat(formatString), parseISO);

export const stripZeroWidthCharacters = (text) => {
    return text?.replace(/[\u200B-\u200D\uFEFF]/g, '');
};
